var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 210",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #e8ba3a;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-1, .cls-3 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-3 {\n        stroke: #193c34;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.387096774194106,
    y: 5.129032258064399,
    width: 239.2258064516118,
    height: 199.7419354838712
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.179162928728147,121.684948436015475c.449905542983288-1.240185584752908,3.278558627841448-7.989669889353536,10.773048998607919-5.450480400735614,.103164221872248,.034952811311086,.162680440143049,.145740808158735,.132664330992156,.250447965920102-.361234858210992,1.260119194470462-2.785037328580984,8.375063891593527-10.781411381348335,5.462791333464338-.106281470745671-.038707620309651-.162875631634961-.156428743735887-.124301948251741-.262758898648826Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.154892609461967,121.684948436015475c-.449905542981469-1.240185584752908-3.278558627839629-7.989669889353536-10.773048998608829-5.450480400735614-.103164221878615,.034952811311086-.162680440145778,.145740808158735-.132664330992156,.250447965920102,.361234858207354,1.260119194470462,2.785037328577346,8.375063891593527,10.781411381346516,5.462791333464338,.106281470745671-.038707620309651,.16287563163678-.156428743735887,.12430194825447-.262758898648826Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 126.15489260946197,
    y1: 121.68494843601547,
    x2: 126.15489260946197,
    y2: 129.70287515868768
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.197094084038326,146.062934917959865c.449905542986926-1.240185584752908,3.278558627843267-7.989669889355355,10.773048998610648-5.450480400735614,.103164221875886,.034952811311086,.162680440146687,.14574080814964,.132664330989428,.250447965901913-.361234858208263,1.260119194488652-2.785037328578255,8.375063891602622-10.781411381346516,5.462791333473433-.106281470741123-.038707620309651-.162875631633142-.156428743726792-.12430194825356-.262758898639731Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.172823764777604,146.062934917959865c-.449905542985107-1.240185584752908-3.27855862783872-7.989669889355355-10.773048998608829-5.450480400735614-.103164221877705,.034952811311086-.162680440144868,.14574080814964-.132664330997613,.250447965901913,.361234858209173,1.260119194488652,2.785037328586441,8.375063891602622,10.781411381350154,5.462791333473433,.106281470743852-.038707620309651,.162875631633142-.156428743726792,.124301948256289-.262758898639731Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 82.1728237647776,
    y1: 146.06293491795986,
    x2: 82.1728237647776,
    y2: 154.08086164062115
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.179162928728147,173.437104422158882c.449905542983288-1.240185584740175,3.278558627841448-7.989669889351717,10.773048998611557-5.450480400733795,.103164221873158,.034952811309267,.162680440144868,.145740808160554,.132664330992156,.250447965912826-.361234858210992,1.260119194477738-2.785037328579165,8.375063891600803-10.781411381350154,5.462791333475252-.106281470745671-.038707620320565-.16287563163678-.156428743739525-.12430194825356-.262758898654283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.154892609461967,173.437104422158882c-.449905542980559-1.240185584740175-3.278558627839629-7.989669889351717-10.773048998608829-5.450480400733795-.103164221873158,.034952811309267-.16268044014123,.145740808160554-.132664330992156,.250447965912826,.361234858211901,1.260119194477738,2.785037328581893,8.375063891600803,10.781411381350154,5.462791333475252,.106281470743852-.038707620320565,.16287563163678-.156428743739525,.124301948250832-.262758898654283Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 126.15489260946197,
    y1: 173.43710442215888,
    x2: 126.15489260946197,
    y2: 181.4550311448238
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M174.263178499699279,146.284957194289746c.44990554297965-1.240185584751089,3.278558627842358-7.989669889353536,10.773048998607919-5.450480400733795,.103164221879524,.034952811309267,.162680440145778,.14574080814964,.132664330994885,.250447965900094-.36123485821372,1.260119194479557-2.785037328580984,8.375063891602622-10.781411381349244,5.462791333475252-.10628147074749-.038707620309651-.16287563163678-.156428743728611-.12430194825356-.26275889864155Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M174.238908180434009,146.284957194289746c-.449905542981469-1.240185584751089-3.278558627840539-7.989669889353536-10.77304899860701-5.450480400733795-.103164221878615,.034952811309267-.162680440145778,.14574080814964-.132664330994885,.250447965900094,.361234858210082,1.260119194479557,2.785037328580074,8.375063891602622,10.781411381352882,5.462791333475252,.106281470742033-.038707620309651,.162875631633142-.156428743728611,.124301948249013-.26275889864155Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 174.238908180434,
    y1: 146.28495719428975,
    x2: 174.238908180434,
    y2: 154.30288391695285
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g4648"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4650",
    className: "cls-1",
    d: "M102.049586219854064,46.247986196998681v5.408755956743335h48.234883098477439v-17.689206763954644c0-.653340500703052-.529528978797316-1.182870357379215-1.182638597593723-1.182870357379215h-45.869374033767599c-.653340281239252,0-1.182870467116118,.529529856676163-1.182870467116118,1.182870357379215v4.225885160418329"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4652"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4654",
    className: "cls-1",
    d: "M112.53333857929556,42.220703373612196h.492479180831651"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4656"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4658",
    className: "cls-1",
    d: "M121.604831063326856,42.220703373612196h18.195724366013565"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4660"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4662",
    className: "cls-1",
    d: "M102.049586219854064,51.656743470563015v18.871846678362999h48.234883098477439v-18.871846678362999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4664"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4666",
    className: "cls-1",
    d: "M112.53333857929556,61.092758986933404h.492479180831651"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4668"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4670",
    className: "cls-1",
    d: "M121.604831063326856,61.092758986933404h18.195724366013565"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4674",
    className: "cls-1",
    d: "M102.049586219854064,70.528544499273266v17.689436329044838c0,.653109618799135,.529530185876865,1.182640353352326,1.182870467116118,1.182640353352326h45.86937052225494c.653109618795497,0,1.182638597596451-.529530734553191,1.182638597596451-1.182640353352326v-17.689436329044838"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4676"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4678",
    className: "cls-1",
    d: "M112.53333857929556,79.964582840468211h.492479180831651"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4680"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4682",
    className: "cls-1",
    d: "M121.604831063326856,79.964582840468211h18.195724366013565"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4684"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4686",
    className: "cls-3",
    d: "M137.832848105434095,21.617286259581306c-1.610683015586801-4.902699240630682-6.232392935589814-8.452001202751489-11.665772930929961-8.452001202751489-5.433609999374312,0-10.055319809644061,3.549301962120808-11.665772930934509,8.452001202751489"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4688"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4690",
    className: "cls-3",
    d: "M119.775916249186594,24.84495567418162c.936861072770625-2.624407683140817,3.448504670055627-4.507795045847161,6.390952623987687-4.507795045847161,2.94290774253659,0,5.45432177472594,1.883387362706344,6.39118262802549,4.507795045847161"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.55161262265392,146.672456321797654l76.621369271313597-44.849446700358385c1.16415742026129-.681426300099702,2.603925705255278-.68791263773528,3.774175568791179-.017003136745188l76.805932271266101,44.033185816679179c2.500558068073587,1.433581167508237,2.528377594747326,5.030560970151782,.050292353386794,6.502647636147231l-76.839644391870024,45.645974577824745c-1.177644687752945,.699570383283572-2.642330156637399,.704299700670163-3.824467922177973,.012348810052572l-76.587657150709674-44.829713694156453c-2.483865503273591-1.453902410763476-2.483865503273591-5.044090898674767,0-6.4979933094437Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 79.52464921260434,
    y1: 171.88550280802156,
    x2: 164.36668526548874,
    y2: 122.68548529147301
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 88.53126120769684,
    y1: 122.68548529147301,
    x2: 172.65141484086416,
    y2: 171.4414582553527
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "68.384390640227139 76.042942960761138 35.46206844077733 76.042942960761138 35.471852872388808 148.687907476894907 45.800491478710683 149.008840309839798"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 71.95073602283333,
    cy: 76.0429429607625,
    r: 3.566345382606073
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 67.69674101138935,
    y1: 87.36221308816675,
    x2: 84.70429722802419,
    y2: 87.36221308816675
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 67.69674101138935,
    y1: 93.56455288400502,
    x2: 84.70429722802419,
    y2: 93.56455288400502
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 67.69674101138935,
    y1: 99.76689267983784,
    x2: 84.70429722802419,
    y2: 99.76689267983784
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "181.615609359772861 76.363875793713305 214.53793155922267 76.363875793713305 214.528147127612101 149.008840309839798 206.645342042986158 149.008840309839798"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 178.04926397716667,
    cy: 76.3638757937133,
    r: 3.566345382607664
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 182.30325898861065,
    y1: 87.68314592111346,
    x2: 165.2957027719758,
    y2: 87.68314592111346
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 182.30325898861065,
    y1: 93.88548571694628,
    x2: 165.2957027719758,
    y2: 93.88548571694628
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 182.30325898861065,
    y1: 100.08782551278273,
    x2: 165.2957027719758,
    y2: 100.08782551278273
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo02);
export default __webpack_public_path__ + "static/media/logo02.14cbd95b8759d651bacdc58f028b3d6b.svg";
export { ForwardRef as ReactComponent };